import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { Survey, Question, CharacteristicScore, Characteristic, SurveyVersion } from '../../models';
import { NavLink } from 'react-router-dom';
import { QuestionDataService, SurveyDataService, CharacteristicDataService, SurveyVersionDataService } from '../../services';
import { QuestionForm } from './QuestionForm';
import { PVAPage } from '../../components';

interface QuestionCreateState {
    question: Question;
    survey: Survey | undefined;
    characteristicScores: CharacteristicScore[];
    characteristics: Characteristic[];
    defaultValues: any;
    hasPublished: boolean;
}

export class QuestionCreate extends React.Component<BaseRouteProps<{ id: number }>, QuestionCreateState> {
    private questionDataService = new QuestionDataService(this.props.notificationService);
    private surveyDataService = new SurveyDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private surveyVersionService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        this.state = {
            question: new Question(),
            survey: undefined,
            characteristicScores: [],
            characteristics: [],
            defaultValues: {},
            hasPublished: false
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {

        this.surveyDataService.get(this.props.match.params.id).then((survey: Survey) => {
            this.setState({
                survey: survey
            });
            
            this.surveyVersionService.getAllBySurvey(survey).then((surveyVersions: SurveyVersion[]) => {
                this.setState({
                    hasPublished: surveyVersions.some(x => x.published !== null)
                });
            });

            this.characteristicDataService.getAll().then((characteristics: Characteristic[]) => {
                this.setState({
                    characteristics: characteristics
                });
            });
        });

    }

    public render() {

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            <NavLink to={`/survey/${this.props.match.params.id}/questions`}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            &nbsp;
                            Create Statement
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <QuestionForm defaultValues={this.state.question} submit={this.save} notificationService={this.props.notificationService} hasPublishedVersion={this.state.hasPublished} />
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        if (!this.state.survey) {
            return;
        }

        values.surveyId = this.state.survey.id;
        this.questionDataService.create(values).then((success) => {
            this.props.history.push(`/survey/${values.surveyId}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/question/QuestionCreate.tsx